<template>
  <div class="product afms" v-bind:class="{contrasted: isPageContrasted, fontBigger: isFontBigger}">
    <header class="page-header" data-aos="fade-up">
      <div class="container">
        <div class="heading-text" data-aos="fade-up" v-if="lang === 'pl'">System monitorowania fauny dla Portów
          Lotniczych
        </div>
        <div class="heading-text" data-aos="fade-up" v-if="lang !== 'pl'">Airport Fauna Monitoring System</div>
        <p data-aos="fade-up" data-aos-delay="100"></p>
        <span class="line" data-aos="zoom-in-left" data-aos-delay="150"></span>
        <p data-aos="fade-up" data-aos-delay="200"></p>
        <div class="btn-hover">
          <router-link to="/products/airport/presentation" class="btn orange" data-aos="fade-up" data-aos-delay="250">
            {{$t('component.watchPresentation')}}<span/></router-link>
        </div>
      </div>
    </header>

    <div id="top" class="why-us-solution">
      <div class="elements">
        <div class="element bps clearfix">
          <div class="text-box">
            <ul v-if="lang === 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
               Zaczynając od roku 2020, przez trzy lata będziemy tworzyć zintegrowany system detekcji ptaków dedykowany dla portów lotniczych. Dzięki naszym wcześniejszym działaniom, kontaktom w branży i poznaniem oczekiwań przedstawicieli lotnisk z całego świata, wiemy dokładnie jak rozwiązanie ma działać. Będzie to system, który z przestrzeni portów lotniczych będzie zbierał informacje o przelatujących ptakach i przekazywał je do mobilnych służb lotniskowych oraz do wieży kontroli lotów. Ponadto, będzie monitorował pas drogi startowej pod kątem obecności zwierząt, które mogą zagrozić operacjom lotniczym. Dzięki naszemu systemowi pracownicy portu będą mogli zredukować ryzyko kolizji samolotów ze zwierzętami. Partnerem strategicznym w tym projekcie jest Port Lotniczy w Gdańsku.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">Tytuł projektu:<br/>
Przeprowadzenie prac badawczo-rozwojowych niezbędnych do opracowania nowego autonomicznego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS) redukującego liczbę kolizji statków powietrznych z ptakami i ssakami.
               </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
                  Cel projektu:<br/>
Celem projektu jest przeprowadzenie prac B+R pozwalających na opracowanie prototypu nowego systemu AIRPORT FAUNA MONITORING SYSTEM (AFMS - system monitoringu okolic portu lotniczego do detekcji awifauny ssaków lądowych).
                <br/><br/><br/>
                Wartosć projektu:<br/>
                3 493 437,50PLN
                  <br/><br/>
                  Dofinansowanie projektu z UE:<br/>
                2 632 075.00PLN
                </span>
              </li>
            </ul>
            <ul v-if="lang !== 'pl'">
              <li>
                <span class="dot"></span>
                <span class="text">
               In the years 2020-23, we will develop an integrated bird detection system dedicated to airports. Thanks to our previous actions, contacts and learning about the expectations of representatives of airport from around the world, we know exactly how the solution shall work. It will be a system that will collect information about flocking birds and transmit data to airport services and to the air traffic control tower. In addition, it will monitor the runway for the presence of animals that may endanger air operations. Thanks to our system, airport personnel will be able to reduce the risk of aircraft collisions with animals. The strategic partner in this project is the Gdańsk Airport.
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">Project title:<br/>
Carrying out research and development works necessary to develop a new autonomous AIRPORT FAUNA MONITORING SYSTEM (AFMS) reducing the number of collisions between aircraft and birds and mammals
                </span>
              </li>
              <li>
                <span class="dot"></span>
                <span class="text">
               The aim of the project is to carry out R&D works enabling the development of a prototype of the new AIRPORT FAUNA MONITORING SYSTEM (AFMS - monitoring system around the airport for the detection of land mammal avifauna).
                <br/><br/><br/>
                Project value:<br/>
                3 493 437,50PLN
                  <br/><br/>
                 Amount of founding from UE:<br/>
                2 632 075.00PLN
                </span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import store from '../store/store';
  import FooterMain from '../components/FooterMain';
  import FooterMoreInformation from '../components/FooterMoreInformation';
  import VideoBox from '../components/VideoBox';
  import Counter from '../components/Counter';
  import smoothScroll from '../helpers/SmoothScroll';

  export default {
    name: 'farms-product',
    components: {
      FooterMain,
      FooterMoreInformation,
      VideoBox,
      Counter
    },
    data: function () {
      return {
        circleValues: [
          {
            before: this.$t('farmsProducts.whyIShouldUseThisOneTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisOneTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisOneTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisTwoTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisTwoTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisTwoTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisThreeTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisThreeTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisThreeTopAfter'),
          },
          {
            before: this.$t('farmsProducts.whyIShouldUseThisFourTopBefore'),
            val: this.$t('farmsProducts.whyIShouldUseThisFourTop'),
            after: this.$t('farmsProducts.whyIShouldUseThisFourTopAfter'),
          },
        ]

      }
    },
    computed: {
      lang: () => {
        return store.state.lang;
      },
      isPageContrasted(){
        return store.state.isPageContrasted
      },
      isFontBigger(){
        return store.state.isPageFontBigger
      },
      smoothScroll: () => smoothScroll
    },
    methods: {},
    mounted: function () {
      store.state.isAccessibilityVisible = true;
    },
    destroyed: function () {
      store.state.isAccessibilityVisible = false;
    },
  }
</script>

<style>
  .afms header.page-header .heading-text {
    max-width: 700px;
  }

  .product.afms .page-header {
    background: url(/static/img/product/header-airport.jpg) no-repeat !important;
    background-position: center center !important;
    background-size: cover !important;
  }

  .product .why-us-solution .elements .element.bps .text-box {
    float: left;
    max-width: initial;
    margin-top: 20px;
    margin-bottom: 100px;
  }

  .product .why-us-solution .elements .element.bps .text-box ul li .text {
    margin-top: -20px;
  }

  .ue{
    position: fixed;
    bottom: 0px;
    left: 0;
    right: 0;
    text-align: center;
  }

  .ue img{
    max-width: 940px;
    width: 35%;
  }

  .product.contrasted{
    background: #000;
    color: yellow;
  }

  .product.contrasted .heading-text{
    color: yellow;
  }
  .product.contrasted .ue{
    background: #000;
  }

  .product.contrasted header a{
    color: yellow;
    background: #000;
  }
  .product.contrasted .btn{
    color: yellow;
    background: #000;
  }
  .product.fontBigger .why-us-solution .elements .element .text-box ul li .text{
    font-size: 1.6em;
    line-height: 1.6em;
  }

</style>



// WEBPACK FOOTER //
// AFMS.vue?62ef3f8a